import { Navigate, useParams } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");
  const { lang } = useParams();
  
  // Preserve language in redirect - use current lang or default to 'es'
  const redirectLang = lang || 'es';
  
  return token ? children : <Navigate to={`/${redirectLang}/login`} replace />;
}
